import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useLockedInvoiceStats from '@/enterprise/data/useLockedInvoiceStats';
import useLocaleFormat from '@/utils/useLocaleFormat';
import { IneligibleInvoiceSource, IneligibleInvoiceUrlState } from './types';
import { mapUrlStateToApiSearchFilters } from './utils';

const IneligibleInvoiceAmount = ({
  urlState,
  source,
}: {
  urlState: IneligibleInvoiceUrlState;
  source: IneligibleInvoiceSource;
}) => {
  const { asCurrency, asNumber } = useLocaleFormat();
  const { t } = useTranslation();
  const { makerOrganizationUuid, currency, takerMarkets } = source;

  const search = useMemo(() => mapUrlStateToApiSearchFilters({ urlState }), [urlState]);

  const { data: ineligibleInvoiceStats } = useLockedInvoiceStats({
    makerOrganizationUuid,
    takerMarkets,
    ...(!!search && {
      search,
    }),
  });

  return (
    <div>
      {asCurrency(ineligibleInvoiceStats?.totalAmount ?? 0, currency)} (
      {t('core.invoiceWithCount', {
        count: ineligibleInvoiceStats?.totalCount,
        formattedCount: asNumber({ value: ineligibleInvoiceStats?.totalCount }),
      })}
      )
    </div>
  );
};

export default IneligibleInvoiceAmount;
